// extracted by mini-css-extract-plugin
export var label = "_hj-2";
export var slideContainer = "_hj-0";
export var slider = "_hj-1";